import { useFeatureOn } from "@services/useFeatureOn";

import { isLandingPageSurveysEnabled } from "./isLandingPageSurveysEnabled";

/**
 * Whether landing-page surveys are available in this workspace.
 * See {@link isLandingPageSurveysEnabled} for prerequisite rationale.
 *
 * @return True when both `landing_pages` and `landing_page_surveys` are enabled
 */
export const useLandingPageSurveysEnabled = (): boolean => {
  const featureOn = useFeatureOn();

  return isLandingPageSurveysEnabled(featureOn);
};
